import React from 'react';

import Bracket from './Bracket';
import JsonLogicBuilder from './index';
import Divider from './Divider';
import Delete from './Delete';

const operators = [
  {value: '==', label: '='},
  {value: '!=', label: '≠'},
  {value: '>=', label: '≥'},
  {value: '<=', label: '≤'},
  {value: '>', label: '>'},
  {value: '<', label: '<'},
  {value: 'in', label: 'in'},
  {value: 'search_list', label: 'Contains'}
];

const arrayOperators = [
  {value: 'some_>', label: 'Any >'},
  {value: 'some_>=', label: 'Any ≥'},
  {value: 'some_<', label: 'Any <'},
  {value: 'some_<=', label: 'Any ≤'},
  {value: 'some_==', label: 'Any ='},
  {value: 'some_!=', label: 'Any ≠'},
  {value: 'all_>', label: 'All >'},
  {value: 'all_>=', label: 'All ≥'},
  {value: 'all_<', label: 'All <'},
  {value: 'all_<=', label: 'All ≤'},
  {value: 'all_==', label: 'All ='},
  {value: 'all_!=', label: 'All ≠'},
  {value: 'sum_>', label: 'Sum >'},
  {value: 'sum_>=', label: 'Sum ≥'},
  {value: 'sum_<', label: 'Sum <'},
  {value: 'sum_<=', label: 'Sum ≤'},
  {value: 'sum_==', label: 'Sum ='},
  {value: 'avg_>', label: 'Average >'},
  {value: 'avg_>=', label: 'Average ≥'},
  {value: 'avg_<', label: 'Average <'},
  {value: 'avg_<=', label: 'Average ≤'},
  {value: 'avg_==', label: 'Average ='}
];

function CompareExpression({variables, operator, value, onChange, onCollapse}) {
  const rightOption = (value[0] && !!value[0].var && variables[value[0].var]) ? variables[value[0].var].options : [];
  const leftOption = (value[1] && !!value[1].var && variables[value[1].var]) ? variables[value[1].var].options : [];

  const leftVariable = value[0] && value[0].var && variables[value[0].var];
  const isMultiValue = leftVariable && leftVariable.isMultiValue;

  return (
    <Bracket onCollapse={onCollapse}>
      <JsonLogicBuilder
        expand
        variables={variables}
        options={leftOption}
        value={value[0]}
        onChange={nextValue => onChange({[operator]: [nextValue, value[1]]})}
      />
      <Divider />
      <ComparisonSelector
        variables={variables}
        value={operator}
        isMultiValue={isMultiValue}
        onChange={nextOperator => onChange({[nextOperator]: value})}
      />
      <Delete onClick={() => onChange(null)} />
      <Divider />
      <JsonLogicBuilder
        expand
        variables={variables}
        value={value[1]}
        options={rightOption}
        onChange={nextValue => onChange({[operator]: [value[0], nextValue]})}
      />
    </Bracket>
  );
}

function ComparisonSelector({value, isMultiValue, onChange}) {
  const availableOperators = isMultiValue ? arrayOperators : operators;
  const isValidOperator = availableOperators.some(op => op.value === value);

  React.useEffect(() => {
    if (!isValidOperator && availableOperators.length > 0) {
      const baseOp = value.replace(/^(some_|all_|sum_|avg_)/, '');
      if (isMultiValue) {
        const defaultOp = `some_${baseOp}`;
        const matchingOp = availableOperators.find(op => op.value === defaultOp);
        onChange(matchingOp ? matchingOp.value : availableOperators[0].value);
      } else {
        const matchingOp = availableOperators.find(op => op.value === baseOp);
        onChange(matchingOp ? matchingOp.value : availableOperators[0].value);
      }
    }
  }, [isMultiValue, value, availableOperators, onChange, isValidOperator]);

  return (
    <select value={value} onChange={e => onChange(e.target.value)}>
      {availableOperators.map(operator => (
        <option key={operator.value} value={operator.value}>
          {operator.label}
        </option>
      ))}
    </select>
  );
}

export default CompareExpression;
